// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3f7c26f3","213":"dbed8829","312":"142793fa","324":"2c0d28d1","484":"304de5c7","551":"044d7706","732":"d57d70d3"}[chunkId] + ".chunk.js";
};